import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const listarEntidadesSalud = () => {
    return axios.get(`${API_URL}/administrar/entidadesSalud`, {
        headers: getHeaders(),
    });
};

export const crearOEditarEntidadSalud = async (entidadSalud) => {
    try {
        if (entidadSalud.id) {
            const resp = await axios.put(
                `${API_URL}/administrar/entidadesSalud/${entidadSalud.id}`,
                entidadSalud,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/administrar/entidadesSalud`,
            entidadSalud,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectTiposParametros = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/administrar/tiposParametros/select`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarEntidadSalud = async (id_entidad_salud) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/administrar/entidadesSalud/${id_entidad_salud}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarEntidadSalud = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/administrar/entidadesSalud/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
